export default [
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.849,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.477,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.846,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.59,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.845,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.682,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.842,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.86,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869167,
        timestamp: '2025-05-22T00:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.837999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871,
        timestamp: '2025-05-21T23:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.764,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871,
        timestamp: '2025-05-21T23:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871,
        timestamp: '2025-05-21T23:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871,
        timestamp: '2025-05-21T23:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.974,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871,
        timestamp: '2025-05-21T23:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.782,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871,
        timestamp: '2025-05-21T23:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.86,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871,
        timestamp: '2025-05-21T23:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871,
        timestamp: '2025-05-21T23:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.166999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T23:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.726,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T23:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T23:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T23:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.268,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T23:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.739,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T23:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T23:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T23:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.427,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T22:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.659,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T22:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T22:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T22:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.733,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T22:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.666,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T22:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.86,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T22:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3868833,
        timestamp: '2025-05-21T22:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.997999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38685,
        timestamp: '2025-05-21T22:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.642,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38685,
        timestamp: '2025-05-21T22:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.6,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38685,
        timestamp: '2025-05-21T22:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38685,
        timestamp: '2025-05-21T22:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.237,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38685,
        timestamp: '2025-05-21T22:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.528,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38685,
        timestamp: '2025-05-21T22:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.62,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38685,
        timestamp: '2025-05-21T22:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38685,
        timestamp: '2025-05-21T22:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.602999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.526,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.658,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 26.058,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.443,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 26.578,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.384,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 27.157999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.277000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T21:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 28.006999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872,
        timestamp: '2025-05-21T20:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.205,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872,
        timestamp: '2025-05-21T20:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.862,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872,
        timestamp: '2025-05-21T20:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872,
        timestamp: '2025-05-21T20:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 28.601,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872,
        timestamp: '2025-05-21T20:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.029,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872,
        timestamp: '2025-05-21T20:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.86,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872,
        timestamp: '2025-05-21T20:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872,
        timestamp: '2025-05-21T20:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 29.659,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T20:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.959,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T20:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T20:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T20:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 30.367,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T20:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.806000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T20:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T20:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T20:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 31.462999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T19:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.681000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T19:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T19:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T19:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 32.444,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T19:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.452999999999999,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T19:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T19:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-21T19:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 33.891999999999996,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.8064333,
        longitude: -122.3272,
        timestamp: '2025-05-21T19:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.154999999999999,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.8064333,
        longitude: -122.3272,
        timestamp: '2025-05-21T19:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.848,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.8064333,
        longitude: -122.3272,
        timestamp: '2025-05-21T19:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.8064333,
        longitude: -122.3272,
        timestamp: '2025-05-21T19:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.231,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.8064333,
        longitude: -122.3272,
        timestamp: '2025-05-21T19:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.845,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.8064333,
        longitude: -122.3272,
        timestamp: '2025-05-21T19:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.593999999999999,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.846,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.816000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.847,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.8580000000000005,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.846,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.947000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.849,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871,
        timestamp: '2025-05-21T18:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-21T17:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.829000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-21T17:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.846,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-21T17:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-21T17:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.7989999999999995,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-21T17:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.846,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-21T17:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3871,
        timestamp: '2025-05-21T17:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.808,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3871,
        timestamp: '2025-05-21T17:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.85,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3871,
        timestamp: '2025-05-21T17:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3871,
        timestamp: '2025-05-21T17:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.521000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3871,
        timestamp: '2025-05-21T17:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.846,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3871,
        timestamp: '2025-05-21T17:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38695,
        timestamp: '2025-05-21T16:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.134,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38695,
        timestamp: '2025-05-21T16:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.843,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38695,
        timestamp: '2025-05-21T16:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38695,
        timestamp: '2025-05-21T16:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.247,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38695,
        timestamp: '2025-05-21T16:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.846,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38695,
        timestamp: '2025-05-21T16:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3868833,
        timestamp: '2025-05-21T16:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.463000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3868833,
        timestamp: '2025-05-21T16:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.847,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3868833,
        timestamp: '2025-05-21T16:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3868833,
        timestamp: '2025-05-21T16:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.877000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3868833,
        timestamp: '2025-05-21T16:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.853,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3868833,
        timestamp: '2025-05-21T16:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.38705,
        timestamp: '2025-05-21T15:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.491,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.38705,
        timestamp: '2025-05-21T15:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.38705,
        timestamp: '2025-05-21T15:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.38705,
        timestamp: '2025-05-21T15:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.828,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.38705,
        timestamp: '2025-05-21T15:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.863,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.38705,
        timestamp: '2025-05-21T15:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38695,
        timestamp: '2025-05-21T15:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.65,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38695,
        timestamp: '2025-05-21T15:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.862,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38695,
        timestamp: '2025-05-21T15:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38695,
        timestamp: '2025-05-21T15:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.444,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38695,
        timestamp: '2025-05-21T15:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38695,
        timestamp: '2025-05-21T15:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870167,
        timestamp: '2025-05-21T14:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.013,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870167,
        timestamp: '2025-05-21T14:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870167,
        timestamp: '2025-05-21T14:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870167,
        timestamp: '2025-05-21T14:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.747999999999999,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870167,
        timestamp: '2025-05-21T14:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870167,
        timestamp: '2025-05-21T14:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T14:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.582000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T14:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T14:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T14:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.218,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T14:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.865,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T14:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T14:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 30.505,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.38715,
        timestamp: '2025-05-21T13:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.619,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.38715,
        timestamp: '2025-05-21T13:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.863,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.38715,
        timestamp: '2025-05-21T13:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.38715,
        timestamp: '2025-05-21T13:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 27.147,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.38715,
        timestamp: '2025-05-21T13:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.134,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.38715,
        timestamp: '2025-05-21T13:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.6,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.38715,
        timestamp: '2025-05-21T13:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.38715,
        timestamp: '2025-05-21T13:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 22.817,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871,
        timestamp: '2025-05-21T13:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.528,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871,
        timestamp: '2025-05-21T13:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.6,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871,
        timestamp: '2025-05-21T13:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871,
        timestamp: '2025-05-21T13:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.576999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871,
        timestamp: '2025-05-21T13:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.747,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871,
        timestamp: '2025-05-21T13:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871,
        timestamp: '2025-05-21T13:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871,
        timestamp: '2025-05-21T13:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 17.99,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3866667,
        timestamp: '2025-05-21T12:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.721,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3866667,
        timestamp: '2025-05-21T12:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3866667,
        timestamp: '2025-05-21T12:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3866667,
        timestamp: '2025-05-21T12:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 17.918,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3866667,
        timestamp: '2025-05-21T12:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.724,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3866667,
        timestamp: '2025-05-21T12:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3866667,
        timestamp: '2025-05-21T12:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3866667,
        timestamp: '2025-05-21T12:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 17.948,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T12:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.723,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T12:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T12:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T12:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 17.986,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T12:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.704,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T12:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T12:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869833,
        timestamp: '2025-05-21T12:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.073999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3869167,
        timestamp: '2025-05-21T11:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.686,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3869167,
        timestamp: '2025-05-21T11:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3869167,
        timestamp: '2025-05-21T11:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3869167,
        timestamp: '2025-05-21T11:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.217,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3869167,
        timestamp: '2025-05-21T11:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.649000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3869167,
        timestamp: '2025-05-21T11:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3869167,
        timestamp: '2025-05-21T11:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3869167,
        timestamp: '2025-05-21T11:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.313,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T11:10:32.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.628,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T11:10:32.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T11:10:32.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T11:10:32.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.386,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:55:32.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.619,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:55:32.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:55:32.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:55:32.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.494999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.597,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.575,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.599,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3870833,
        timestamp: '2025-05-21T10:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.692,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T10:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.559000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T10:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T10:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T10:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.785,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T09:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.56,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T09:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T09:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T09:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.863999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.537,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.986,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.509,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.07,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.489,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T09:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.174999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T08:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.491,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T08:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T08:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.38725,
        timestamp: '2025-05-21T08:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.259,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3871,
        timestamp: '2025-05-21T08:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.48,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3871,
        timestamp: '2025-05-21T08:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3871,
        timestamp: '2025-05-21T08:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3871,
        timestamp: '2025-05-21T08:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.362,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3871,
        timestamp: '2025-05-21T08:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.462,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3871,
        timestamp: '2025-05-21T08:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3871,
        timestamp: '2025-05-21T08:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3871,
        timestamp: '2025-05-21T08:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.451,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T08:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.442,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T08:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T08:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T08:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.544,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.43,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.64,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.425,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.732,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.396,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869,
        timestamp: '2025-05-21T07:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.773999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869167,
        timestamp: '2025-05-21T07:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.389,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869167,
        timestamp: '2025-05-21T07:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869167,
        timestamp: '2025-05-21T07:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869167,
        timestamp: '2025-05-21T07:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.887,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869167,
        timestamp: '2025-05-21T06:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.370000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869167,
        timestamp: '2025-05-21T06:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869167,
        timestamp: '2025-05-21T06:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869167,
        timestamp: '2025-05-21T06:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.983,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.359,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.096,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.327,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.197,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.325000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T06:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.343,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T05:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.32,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T05:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T05:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3866333,
        timestamp: '2025-05-21T05:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.451999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3813333,
        timestamp: '2025-05-21T05:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.282,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3813333,
        timestamp: '2025-05-21T05:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3813333,
        timestamp: '2025-05-21T05:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3813333,
        timestamp: '2025-05-21T05:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.552,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3813333,
        timestamp: '2025-05-21T05:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.273,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3813333,
        timestamp: '2025-05-21T05:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3813333,
        timestamp: '2025-05-21T05:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3813333,
        timestamp: '2025-05-21T05:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.694,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T05:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.25,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T05:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T05:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T05:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.776999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.235,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.881999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.221,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.046,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.174,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871167,
        timestamp: '2025-05-21T04:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.258,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T04:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.158,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T04:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T04:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T04:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.407999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.129,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.558,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.071,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.814,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.05,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 22.067999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.957,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T03:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 22.43,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T02:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.962,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T02:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T02:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870167,
        timestamp: '2025-05-21T02:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 22.695,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3872,
        timestamp: '2025-05-21T02:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.92,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3872,
        timestamp: '2025-05-21T02:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3872,
        timestamp: '2025-05-21T02:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3872,
        timestamp: '2025-05-21T02:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.067999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3872,
        timestamp: '2025-05-21T02:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.901,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3872,
        timestamp: '2025-05-21T02:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3872,
        timestamp: '2025-05-21T02:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3872,
        timestamp: '2025-05-21T02:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.226,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T02:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.856,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T02:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T02:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T02:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.397,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.846,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.573,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.847,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.86,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.715,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.811,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883833,
        longitude: -122.3870667,
        timestamp: '2025-05-21T01:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.836,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3868833,
        timestamp: '2025-05-21T01:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.784,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3868833,
        timestamp: '2025-05-21T01:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3868833,
        timestamp: '2025-05-21T01:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3868833,
        timestamp: '2025-05-21T01:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.924,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3868833,
        timestamp: '2025-05-21T00:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.808,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3868833,
        timestamp: '2025-05-21T00:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.86,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3868833,
        timestamp: '2025-05-21T00:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3868833,
        timestamp: '2025-05-21T00:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.017,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.8,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.121,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.745000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.192,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.773,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-21T00:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.284,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-20T23:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.75,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-20T23:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-20T23:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-20T23:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.439999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.387,
        timestamp: '2025-05-20T23:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.734,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.387,
        timestamp: '2025-05-20T23:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.387,
        timestamp: '2025-05-20T23:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.387,
        timestamp: '2025-05-20T23:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.607,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.387,
        timestamp: '2025-05-20T23:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.674,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.387,
        timestamp: '2025-05-20T23:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.387,
        timestamp: '2025-05-20T23:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.387,
        timestamp: '2025-05-20T23:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.733,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T23:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.671,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T23:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T23:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T23:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.901,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.651,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.157,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.594,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.430999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.578,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3868,
        timestamp: '2025-05-20T22:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.772,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883333,
        longitude: -122.3868667,
        timestamp: '2025-05-20T22:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.441,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883333,
        longitude: -122.3868667,
        timestamp: '2025-05-20T22:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883333,
        longitude: -122.3868667,
        timestamp: '2025-05-20T22:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883333,
        longitude: -122.3868667,
        timestamp: '2025-05-20T22:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 26.383,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883333,
        longitude: -122.3868667,
        timestamp: '2025-05-20T21:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.434000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883333,
        longitude: -122.3868667,
        timestamp: '2025-05-20T21:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883333,
        longitude: -122.3868667,
        timestamp: '2025-05-20T21:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883333,
        longitude: -122.3868667,
        timestamp: '2025-05-20T21:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 26.759999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.349,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 27.374,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.229000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.862,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 28.268,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.153,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.862,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T21:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 28.875999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T20:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.063,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T20:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T20:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-20T20:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 29.500999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-20T20:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.936999999999999,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-20T20:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-20T20:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-20T20:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 30.505,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-20T20:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.836,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-20T20:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-20T20:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-20T20:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 31.299,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T20:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.6690000000000005,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T20:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T20:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T20:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 32.734,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T19:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.441000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T19:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T19:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T19:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 34.118,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T19:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.186999999999999,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T19:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.849,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T19:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T19:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.213000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T19:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.847,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T19:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78875,
        longitude: -122.3970333,
        timestamp: '2025-05-20T19:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.449,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78875,
        longitude: -122.3970333,
        timestamp: '2025-05-20T19:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.849,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78875,
        longitude: -122.3970333,
        timestamp: '2025-05-20T19:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78875,
        longitude: -122.3970333,
        timestamp: '2025-05-20T18:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.707000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78875,
        longitude: -122.3970333,
        timestamp: '2025-05-20T18:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.847,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78875,
        longitude: -122.3970333,
        timestamp: '2025-05-20T18:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T18:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.959,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T18:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.847,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T18:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T18:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.058,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T18:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.849,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T18:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T18:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.021,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T18:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.847,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T18:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T17:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.973000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T17:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.848,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.38705,
        timestamp: '2025-05-20T17:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3879833,
        timestamp: '2025-05-20T17:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.893000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3879833,
        timestamp: '2025-05-20T17:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.852,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3879833,
        timestamp: '2025-05-20T17:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3879833,
        timestamp: '2025-05-20T17:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.776,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3879833,
        timestamp: '2025-05-20T17:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.848,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.3879833,
        timestamp: '2025-05-20T17:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T17:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.630000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T17:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.85,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T17:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T16:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.215999999999999,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T16:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.847,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T16:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T16:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.334,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T16:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.848,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T16:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T16:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.606,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T16:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.853,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870333,
        timestamp: '2025-05-20T16:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871667,
        timestamp: '2025-05-20T16:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.945,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871667,
        timestamp: '2025-05-20T16:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.854,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871667,
        timestamp: '2025-05-20T16:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.603,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.865,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.950000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.867,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.755,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.864,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.545,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.862,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T15:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T14:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.297,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T14:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3871667,
        timestamp: '2025-05-20T14:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869667,
        timestamp: '2025-05-20T14:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.975,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869667,
        timestamp: '2025-05-20T14:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869667,
        timestamp: '2025-05-20T14:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869667,
        timestamp: '2025-05-20T14:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.371,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869667,
        timestamp: '2025-05-20T14:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.851,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3869667,
        timestamp: '2025-05-20T14:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T14:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.8870000000000005,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T14:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.864,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T14:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T14:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 33.021,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.385,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.868,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 29.208,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.845,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.64,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.343,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869333,
        timestamp: '2025-05-20T13:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.869,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3868333,
        timestamp: '2025-05-20T13:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.539,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3868333,
        timestamp: '2025-05-20T13:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3868333,
        timestamp: '2025-05-20T13:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3868333,
        timestamp: '2025-05-20T13:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.887,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.525,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.839,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.492,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.909,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.485,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 18.974,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.466000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T12:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.07,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T11:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.459,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T11:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T11:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78855,
        longitude: -122.3868333,
        timestamp: '2025-05-20T11:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.141,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870167,
        timestamp: '2025-05-20T11:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.52,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870167,
        timestamp: '2025-05-20T11:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870167,
        timestamp: '2025-05-20T11:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870167,
        timestamp: '2025-05-20T11:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.233999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870167,
        timestamp: '2025-05-20T11:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.428,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870167,
        timestamp: '2025-05-20T11:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870167,
        timestamp: '2025-05-20T11:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3870167,
        timestamp: '2025-05-20T11:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.352999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T11:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.421,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T11:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T11:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T11:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.422,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.414,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.49,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.441,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.569,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.402000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7882833,
        longitude: -122.38675,
        timestamp: '2025-05-20T10:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.627,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-20T10:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.337,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-20T10:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-20T10:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-20T10:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.706999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-20T09:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.339,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-20T09:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-20T09:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.387,
        timestamp: '2025-05-20T09:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.773999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.383000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.840999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.376,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.9,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.319,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T09:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.958,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T08:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.319,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T08:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T08:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78835,
        longitude: -122.38715,
        timestamp: '2025-05-20T08:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.012999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872167,
        timestamp: '2025-05-20T08:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.338000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872167,
        timestamp: '2025-05-20T08:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872167,
        timestamp: '2025-05-20T08:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872167,
        timestamp: '2025-05-20T08:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.092,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872167,
        timestamp: '2025-05-20T08:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.290000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872167,
        timestamp: '2025-05-20T08:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872167,
        timestamp: '2025-05-20T08:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3872167,
        timestamp: '2025-05-20T08:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.201999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T08:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.327,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T08:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T08:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T08:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.285,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.238,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.368,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.279,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.435,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.238,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3869667,
        timestamp: '2025-05-20T07:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.544,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7887667,
        longitude: -122.3868833,
        timestamp: '2025-05-20T07:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.236,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7887667,
        longitude: -122.3868833,
        timestamp: '2025-05-20T07:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7887667,
        longitude: -122.3868833,
        timestamp: '2025-05-20T07:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7887667,
        longitude: -122.3868833,
        timestamp: '2025-05-20T07:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.631,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7887667,
        longitude: -122.3868833,
        timestamp: '2025-05-20T06:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.238,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7887667,
        longitude: -122.3868833,
        timestamp: '2025-05-20T06:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7887667,
        longitude: -122.3868833,
        timestamp: '2025-05-20T06:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 23,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7887667,
        longitude: -122.3868833,
        timestamp: '2025-05-20T06:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.723,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.182,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.814999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.201,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.907,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.176,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T06:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.968,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T05:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.159,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T05:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T05:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38705,
        timestamp: '2025-05-20T05:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.083,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3872,
        timestamp: '2025-05-20T05:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.162,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3872,
        timestamp: '2025-05-20T05:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3872,
        timestamp: '2025-05-20T05:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3872,
        timestamp: '2025-05-20T05:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.141,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3872,
        timestamp: '2025-05-20T05:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.125,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3872,
        timestamp: '2025-05-20T05:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3872,
        timestamp: '2025-05-20T05:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3872,
        timestamp: '2025-05-20T05:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.320999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T05:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.108,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T05:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T05:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T05:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.416999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.092,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.555,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.068,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.703,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.049,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3870667,
        timestamp: '2025-05-20T04:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 21.846999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3867833,
        timestamp: '2025-05-20T04:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.016,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3867833,
        timestamp: '2025-05-20T04:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3867833,
        timestamp: '2025-05-20T04:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3867833,
        timestamp: '2025-05-20T04:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 22.048,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3867833,
        timestamp: '2025-05-20T03:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.99,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3867833,
        timestamp: '2025-05-20T03:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3867833,
        timestamp: '2025-05-20T03:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7882667,
        longitude: -122.3867833,
        timestamp: '2025-05-20T03:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 22.253999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.948,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 22.523999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.892,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 22.737,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.84,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T03:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.23,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T02:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.836,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T02:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T02:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3865,
        timestamp: '2025-05-20T02:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.401,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3867167,
        timestamp: '2025-05-20T02:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.772,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3867167,
        timestamp: '2025-05-20T02:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3867167,
        timestamp: '2025-05-20T02:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3867167,
        timestamp: '2025-05-20T02:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.615,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3867167,
        timestamp: '2025-05-20T02:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.778,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3867167,
        timestamp: '2025-05-20T02:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3867167,
        timestamp: '2025-05-20T02:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7883667,
        longitude: -122.3867167,
        timestamp: '2025-05-20T02:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.832,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T02:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.753,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T02:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T02:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T02:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 23.933,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.724,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.111,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.708,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.192999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.731,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78825,
        longitude: -122.3868,
        timestamp: '2025-05-20T01:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.302,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3868167,
        timestamp: '2025-05-20T01:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.724,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3868167,
        timestamp: '2025-05-20T01:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3868167,
        timestamp: '2025-05-20T01:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3868167,
        timestamp: '2025-05-20T01:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.401999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3868167,
        timestamp: '2025-05-20T00:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.707,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3868167,
        timestamp: '2025-05-20T00:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3868167,
        timestamp: '2025-05-20T00:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3868167,
        timestamp: '2025-05-20T00:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.451999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.681000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.535999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.658,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.624,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.628,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-20T00:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.717,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-19T23:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.644,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-19T23:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-19T23:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885333,
        longitude: -122.3868333,
        timestamp: '2025-05-19T23:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.855,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871833,
        timestamp: '2025-05-19T23:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.621,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871833,
        timestamp: '2025-05-19T23:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871833,
        timestamp: '2025-05-19T23:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871833,
        timestamp: '2025-05-19T23:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 24.942999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871833,
        timestamp: '2025-05-19T23:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.608,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871833,
        timestamp: '2025-05-19T23:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871833,
        timestamp: '2025-05-19T23:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3871833,
        timestamp: '2025-05-19T23:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.102999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T23:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.577,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T23:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T23:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T23:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.195,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.551,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.368,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.552,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.604,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.48,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870833,
        timestamp: '2025-05-19T22:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.961,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7886833,
        longitude: -122.3873333,
        timestamp: '2025-05-19T22:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.467,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7886833,
        longitude: -122.3873333,
        timestamp: '2025-05-19T22:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7886833,
        longitude: -122.3873333,
        timestamp: '2025-05-19T22:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7886833,
        longitude: -122.3873333,
        timestamp: '2025-05-19T22:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 26.21,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7886833,
        longitude: -122.3873333,
        timestamp: '2025-05-19T21:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.42,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7886833,
        longitude: -122.3873333,
        timestamp: '2025-05-19T21:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7886833,
        longitude: -122.3873333,
        timestamp: '2025-05-19T21:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7886833,
        longitude: -122.3873333,
        timestamp: '2025-05-19T21:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 26.633,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.351,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.86,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 27.064,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.26,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 27.735,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.205,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T21:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 28.208,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T20:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.13,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T20:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.862,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T20:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T20:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 28.878999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3864,
        timestamp: '2025-05-19T20:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.03,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3864,
        timestamp: '2025-05-19T20:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3864,
        timestamp: '2025-05-19T20:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3864,
        timestamp: '2025-05-19T20:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 29.612,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3864,
        timestamp: '2025-05-19T20:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.931000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3864,
        timestamp: '2025-05-19T20:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.862,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3864,
        timestamp: '2025-05-19T20:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885,
        longitude: -122.3864,
        timestamp: '2025-05-19T20:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 30.471,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869833,
        timestamp: '2025-05-19T20:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.793000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869833,
        timestamp: '2025-05-19T20:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.863,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869833,
        timestamp: '2025-05-19T20:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869833,
        timestamp: '2025-05-19T20:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 31.573999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869833,
        timestamp: '2025-05-19T19:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.5280000000000005,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869833,
        timestamp: '2025-05-19T19:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.858,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869833,
        timestamp: '2025-05-19T19:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3869833,
        timestamp: '2025-05-19T19:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 33.28,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.38705,
        timestamp: '2025-05-19T19:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.486000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.38705,
        timestamp: '2025-05-19T19:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.847,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.38705,
        timestamp: '2025-05-19T19:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.38705,
        timestamp: '2025-05-19T18:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.788,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.38705,
        timestamp: '2025-05-19T18:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.847,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.38705,
        timestamp: '2025-05-19T18:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T18:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.042,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T18:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.846,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T18:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T18:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.058,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T18:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.843,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T18:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T18:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.960000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T18:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.841,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T18:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T17:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.849,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T17:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.841,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3870833,
        timestamp: '2025-05-19T17:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869,
        timestamp: '2025-05-19T17:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.673,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869,
        timestamp: '2025-05-19T17:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.842,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869,
        timestamp: '2025-05-19T17:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869,
        timestamp: '2025-05-19T17:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.462,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869,
        timestamp: '2025-05-19T17:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.842,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.3869,
        timestamp: '2025-05-19T17:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T17:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.266,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T17:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.841,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T17:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T16:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.197000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T16:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.843,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T16:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T16:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.285,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T16:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.847,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T16:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T16:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.468,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T16:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.848,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884,
        longitude: -122.3869667,
        timestamp: '2025-05-19T16:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7897,
        longitude: -122.3929,
        timestamp: '2025-05-19T16:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.683,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7897,
        longitude: -122.3929,
        timestamp: '2025-05-19T16:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.852,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7897,
        longitude: -122.3929,
        timestamp: '2025-05-19T16:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7897,
        longitude: -122.3929,
        timestamp: '2025-05-19T15:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.137,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7897,
        longitude: -122.3929,
        timestamp: '2025-05-19T15:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7897,
        longitude: -122.3929,
        timestamp: '2025-05-19T15:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T15:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.613,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T15:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.862,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T15:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T15:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.536,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T15:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.861,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T15:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T15:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.381,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T15:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.859,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T15:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T14:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.018,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T14:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3867833,
        timestamp: '2025-05-19T14:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3868833,
        timestamp: '2025-05-19T14:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.729000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3868833,
        timestamp: '2025-05-19T14:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.853,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3868833,
        timestamp: '2025-05-19T14:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3868833,
        timestamp: '2025-05-19T14:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.34,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3868833,
        timestamp: '2025-05-19T14:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.85,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885667,
        longitude: -122.3868833,
        timestamp: '2025-05-19T14:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T14:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 7.667,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T14:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T14:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T14:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 34.01,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.418000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.863,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 28.165,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 8.769,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.862,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 25.148,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.271,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.3871167,
        timestamp: '2025-05-19T13:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.894,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-19T13:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.475,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-19T13:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-19T13:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-19T13:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.141,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-19T12:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.468,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-19T12:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-19T12:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884667,
        longitude: -122.3870667,
        timestamp: '2025-05-19T12:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.028,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.463000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.066,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.443,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.116,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:10:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.455,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:10:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:10:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T12:10:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.171,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:55:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.452,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:55:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:55:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885167,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:55:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.233999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.43,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.279999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.412,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884833,
        longitude: -122.3870167,
        timestamp: '2025-05-19T11:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.36,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T11:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.409,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T11:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T11:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T11:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.41,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.397,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.464,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.381,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.531,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.374,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.3870333,
        timestamp: '2025-05-19T10:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.581999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-05-19T10:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.356,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-05-19T10:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-05-19T10:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-05-19T10:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.631999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-05-19T09:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.357000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-05-19T09:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-05-19T09:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.387,
        timestamp: '2025-05-19T09:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.730999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:40:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.329,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:40:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.855,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:40:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:40:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.794999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:25:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.34,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:25:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:25:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:25:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.878,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.317,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T09:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 19.942999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.311,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.78845,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.029,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.291,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.08,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.277000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884167,
        longitude: -122.38715,
        timestamp: '2025-05-19T08:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.145999999999997,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T08:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.267,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T08:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T08:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T08:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.233,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.262,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.279999999999998,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:40:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.25,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:40:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.857,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:40:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:40:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.372,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:25:30.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.231,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:25:30.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:25:30.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7884333,
        longitude: -122.38705,
        timestamp: '2025-05-19T07:25:30.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.41,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.387,
        timestamp: '2025-05-19T07:10:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.215,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.387,
        timestamp: '2025-05-19T07:10:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.387,
        timestamp: '2025-05-19T07:10:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.387,
        timestamp: '2025-05-19T07:10:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.503,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.387,
        timestamp: '2025-05-19T06:55:31.000Z',
        sensorPosition: 1,
        units: 'mg/L',
        value: 9.213000000000001,
        unit_type: 'mass_concentration',
        data_type_name: 'bm_do_mg_per_l_mean_17bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.387,
        timestamp: '2025-05-19T06:55:31.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0.856,
        unit_type: 'quality_ratio',
        data_type_name: 'bm_do_quality_mean_10bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.387,
        timestamp: '2025-05-19T06:55:31.000Z',
        sensorPosition: 1,
        units: '%',
        value: 0,
        unit_type: 'percentage',
        data_type_name: 'bm_do_saturation_pct_mean_18bits',
    },
    {
        latitude: 37.7885833,
        longitude: -122.387,
        timestamp: '2025-05-19T06:55:31.000Z',
        sensorPosition: 1,
        units: '°C',
        value: 20.534,
        unit_type: 'temperature',
        data_type_name: 'bm_do_temperature_mean_16bits',
    },
];
